import { Cr } from "@cimo/request/dist/src/Main";

// Source
import * as HelperSrc from "./HelperSrc";
import * as ModelHelperSrc from "./model/HelperSrc";
import { store } from "./store";
import { logout } from "./actions/logout";

export const api = new Cr(`${HelperSrc.URL_BACKEND || ""}`, HelperSrc.REQUEST_TIMEOUT, HelperSrc.REQUEST_IS_ENCODED);

api.setRequestInterceptor((config) => {
    return requestLogic(config);
});

api.setResponseInterceptor((response: Response) => {
    return responseLogic(response);
});

const requestLogic = (config: RequestInit): RequestInit => {
    return {
        ...config,
        headers: {
            ...config.headers
        },
        credentials: "include"
    };
};

const isSessionExpiredPayload = (result: unknown): boolean => {
    if (!result || typeof result !== "object") {
        return false;
    }

    const obj = result as { message?: unknown };
    return obj.message === "session_expired";
};

const responseLogic = (response: Response) => {
    response
        .clone()
        .json()
        .then((result: unknown) => {
            if (isSessionExpiredPayload(result)) {
                store.setIsSessionExpired(true);
                logout();
                return;
            }

            if (response.status === 403) {
                const typed = result as ModelHelperSrc.Iresponse;
                if (typed?.message?.error) {
                    alert(typed.message.error);
                }
            } else if (response.status === 500) {
                alert(response.status);
                HelperSrc.writeLog("error", response.status.toString());
            }
        })
        .catch(() => {
            if (response.status === 500) {
                alert(response.status);
                HelperSrc.writeLog("error", response.status.toString());
            }
        });

    return response;
};
